import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as PropTypes from "prop-types";
import { SearchkitComponent, NumericOptionsAccessor, RenderComponentPropType, renderComponent } from "../../../../../core";
import { ItemList, Panel } from "../../../../ui";

var defaults = require("lodash/defaults");

var map = require("lodash/map");

export var NumericRefinementListFilter =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(NumericRefinementListFilter, _SearchkitComponent);

  function NumericRefinementListFilter(props) {
    var _this;

    _classCallCheck(this, NumericRefinementListFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumericRefinementListFilter).call(this, props));
    _this.toggleItem = _this.toggleItem.bind(_assertThisInitialized(_this));
    _this.setItems = _this.setItems.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NumericRefinementListFilter, [{
    key: "defineAccessor",
    value: function defineAccessor() {
      var _this$props = this.props,
          id = _this$props.id,
          field = _this$props.field,
          options = _this$props.options,
          title = _this$props.title,
          multiselect = _this$props.multiselect,
          fieldOptions = _this$props.fieldOptions;
      return new NumericOptionsAccessor(id, {
        id: id,
        field: field,
        options: options,
        title: title,
        multiselect: multiselect,
        fieldOptions: fieldOptions
      });
    }
  }, {
    key: "toggleItem",
    value: function toggleItem(key) {
      this.accessor.toggleOption(key);
    }
  }, {
    key: "setItems",
    value: function setItems(keys) {
      this.accessor.setOptions(keys);
    }
  }, {
    key: "getSelectedItems",
    value: function getSelectedItems() {
      var selectedOptions = this.accessor.getSelectedOrDefaultOptions() || [];
      return map(selectedOptions, "title");
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return this.accessor.getBuckets().length != 0;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.accessor) return null;
      var _this$props2 = this.props,
          listComponent = _this$props2.listComponent,
          containerComponent = _this$props2.containerComponent,
          itemComponent = _this$props2.itemComponent,
          showCount = _this$props2.showCount,
          title = _this$props2.title,
          id = _this$props2.id,
          mod = _this$props2.mod,
          className = _this$props2.className,
          countFormatter = _this$props2.countFormatter;
      return renderComponent(containerComponent, {
        title: title,
        className: id ? "filter--".concat(id) : undefined,
        disabled: !this.hasOptions()
      }, renderComponent(listComponent, {
        mod: mod,
        className: className,
        items: this.accessor.getBuckets(),
        itemComponent: itemComponent,
        selectedItems: this.getSelectedItems(),
        toggleItem: this.toggleItem,
        setItems: this.setItems,
        docCount: this.accessor.getDocCount(),
        showCount: showCount,
        translate: this.translate,
        countFormatter: countFormatter
      }));
    }
  }]);

  return NumericRefinementListFilter;
}(SearchkitComponent);
NumericRefinementListFilter.propTypes = defaults({
  containerComponent: RenderComponentPropType,
  listComponent: RenderComponentPropType,
  itemComponent: RenderComponentPropType,
  field: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  multiselect: PropTypes.bool,
  showCount: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    from: PropTypes.number,
    to: PropTypes.number,
    key: PropTypes.string
  })),
  fieldOptions: PropTypes.shape({
    type: PropTypes.oneOf(["embedded", "nested", "children"]).isRequired,
    options: PropTypes.object
  }),
  countFormatter: PropTypes.func
}, SearchkitComponent.propTypes);
NumericRefinementListFilter.defaultProps = {
  listComponent: ItemList,
  containerComponent: Panel,
  multiselect: false,
  showCount: true
};